// @flow

// force flow to type check this file - https://github.com/zapier/zapier/pull/31127
import React from 'react'; /* eslint-disable-line no-unused-vars */

import { Colors } from '@zapier/design-system';
import { jsx } from '@emotion/core';

import { getPathColorStyle } from './utils';

/** @jsx jsx */

const smallIcon = {
  fontSize: '8px',
  borderRadius: '4px',
  height: '14px',
  width: '14px',
};

const mediumIcon = {
  fontSize: '12px',
  borderRadius: '4px',
  height: '18px',
  width: '18px',
};

const mediumLargeIcon = {
  fontSize: '12px',
  borderRadius: '5px',
  height: '20px',
  width: '20px',
};

const largeIcon = {
  fontSize: '14px',
  borderRadius: '6px',
  height: '24px',
  width: '24px',
};

const xLargeIcon = {
  fontSize: '18px',
  borderRadius: '10px',
  height: '35px',
  width: '35px',
};

const megaIcon = {
  fontSize: '18px',
  borderRadius: '10px',
  height: '40px',
  width: '40px',
};

type Props = {
  /** The path letter - 'A', 'B', 'C' etc. */
  emoji: string,

  /** The path color name - 'Heroine Blue', etc. */
  color: ?string,

  /** The icon size. */
  size: 'small' | 'medium' | 'medium-large' | 'large' | 'x-large' | 'mega',

  /**
   * The class name prop is used for legacy styles in the beta editor.
   * Consider it deprecated - please do not use for new stuff.
   */
  className?: string,
};

const PathIcon = ({ emoji, size, className, color }: Props) => {
  const backgroundColor = getPathColorStyle(color);

  const iconStyle = {
    display: 'flex',
    justifyContent: 'center',
    alignItems: 'center',
    fontWeight: '600',
    backgroundColor,
    color: Colors.white,
    ...{
      small: smallIcon,
      medium: mediumIcon,
      'medium-large': mediumLargeIcon,
      large: largeIcon,
      'x-large': xLargeIcon,
      mega: megaIcon,
    }[size],
  };

  return (
    <div className={className} css={iconStyle}>
      {emoji}
    </div>
  );
};

export default PathIcon;
